import axios from "axios";
import Config from "src/config";

const v2_actionEditarCliente = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${id}/editar`,
        data: data
    });
};

export default v2_actionEditarCliente;
